import { render, staticRenderFns } from "./EditorTopInnerSections.vue?vue&type=template&id=000cd2fe&"
import script from "./EditorTopInnerSections.vue?vue&type=script&lang=js&"
export * from "./EditorTopInnerSections.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports